export default __webpack_public_path__ + "static/media/CNo.30-3.c0d4f84b.jpg";